import { Component, Input, ViewChild, ViewContainerRef } from '@angular/core';
@Component({
  moduleId: module.id,
  selector: 'icon-home',
  template: `
    <ng-template #template>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" [ngClass]="class">
        <path
          d="M2 12.2C2 9.9 2 8.7 2.5 7.8C3 6.9 4 6.3 6 5L8 3.7C10 2.4 11 2 12 2C13 2 14 2.4 16 3.7L18 5C20 6.3 21 6.9 21.5 7.8C22 8.7 22 9.9 22 12.2V13.7C22 17.6 22 19.6 20.8 20.8C19.6 22 17.7 22 14 22H10C6.3 22 4.4 22 3.2 20.8C2 19.6 2 17.6 2 13.7V12.2Z"
          stroke="currentColor"
          stroke-width="2"
        />
        <path d="M12 15V18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      </svg>
    </ng-template>
  `,
})
export class IconHomeComponent {
  @Input() class: any = '';
  @ViewChild('template', { static: true }) template: any;
  constructor(private viewContainerRef: ViewContainerRef) {
    // do nothing
  }
  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);
    this.viewContainerRef.element.nativeElement.remove();
  }
}
